import axios from "axios";
import { baseAlert } from "../Helpers/AlertHelper";

const HttpServices = axios.create({
    baseURL: `${process.env.REACT_APP_API_ENDPOINT}`
})

export const ActiviateHttpServices = async (instance) => {

    HttpServices.interceptors.request.use(
        async (config) => {
            config!.headers!.Authorization = `Bearer ${instance.accessToken}`
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    )

    HttpServices.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data

        return response;
    }, async function (error) {
        const { config, message, response } = error;
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        let ErrorMessage = "";
        let SubErrorMessage = "";

        if (response?.status === 409) {
            ErrorMessage = error.response.data.Message
            baseAlert(ErrorMessage, undefined, "error")
        }
        else if (response?.status === 404) {
            baseAlert("Not Found", undefined, "error")
            return Promise.reject(error);
        }
        else if (response?.status === 403) {
            baseAlert("You don't have permission to access this resource", undefined, "error")
            return Promise.reject(error);
        }
        else if (response?.status === 400 && !Boolean(config.headers['skipError'])) {
            if (response.data.errors) {
                Object.values(response.data.errors).map((error: any) => {
                    SubErrorMessage += error[0] + "<br/>"
                })
            }
            else if(response.data.Message){
                SubErrorMessage += response.data.Message + "<br/>"
            }

            ErrorMessage = "Invalid request";

            baseAlert(ErrorMessage, SubErrorMessage, "warning")
            return Promise.reject(error);
        }
        else if (message !== "canceled" && !Boolean(config.headers['skipError'])) {
            baseAlert("An error has occurred", undefined, "error")
            return Promise.reject(error);
        }

    });
}

export default HttpServices;